import React from "react";
import "../../css/Wireframe.css";
import Footer from "../../components/Footer";
import Banner from "../../components/Banner";
import Select from "react-select";
import axios from "axios";
import OtpInput from "../../components/OtpInput";
import Spinner from "../../components/Spinner";
import { Sidebar } from "./../../components/Sidebar";

const API = localStorage.getItem("assethost");
const usernameRegex = /^(?!\s*$)[-_a-zA-Z0-9 ]*$/;
const usernameError =
  "Username should only contain letters, digits, dash, or underscore";
const passwordRegex =
  // eslint-disable-next-line no-useless-escape
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/;
const passwordError =
  "Password must be at least 8 characters, with uppercase, lowercase, number, and symbol.";
const nationalIdRegex = /^\d{2}-\d{6,7}[A-Z]\d{2}$/;
const ogPlaceholder = "00-000000(0)A00";
const placeholder1 = "00-000000A00";
const placeholder2 = "00-0000000A00";
const phoneRegex =
  /^\+?[0-9]{1,4}?[-.\s]?\(?[0-9]{1,3}?\)?[-.\s]?[0-9]{3,4}[-.\s]?[0-9]{3,4}$/;
const phoneError = "Not a valid phone number";

function dynamicNationalIdError(id) {
  const start = "Accepted format for national ID is ";
  let last = "";
  if (id.length >= 10 && /[A-Z]/.test(id[9]))
    last = id + placeholder1.substring(id.length);
  else if (id.length >= 10) last = id + placeholder2.substring(id.length);
  else last = id + ogPlaceholder.substring(id.length);
  return start + last;
}
function formatNationalId(e, state, field, isZimbabwean = true) {
  let currentValue = String(state[field] || "");
  let newValue = currentValue;
  let newPlaceholder =
    currentValue + ogPlaceholder.substring(currentValue.length);
  let error = "";
  e = e.toUpperCase();
  if (!isZimbabwean) {
    const newState = { ...state, [field]: e };
    return { newPlaceholder, error, newState };
  }
  if (e.length > currentValue.length && nationalIdRegex.test(currentValue)) {
    return { newPlaceholder, error, newState: state };
  }
  if (nationalIdRegex.test(e)) {
    newValue = e;
    newPlaceholder = e;
  } else if (
    nationalIdRegex.test(e + placeholder1.substring(e.length)) ||
    nationalIdRegex.test(e + placeholder2.substring(e.length))
  ) {
    if (e.length >= 10) {
      newValue = e;
      newPlaceholder = /[A-Z]/.test(e[9])
        ? e + placeholder1.substring(e.length)
        : e + placeholder2.substring(e.length);
    } else if (e.length === 2 && currentValue.length < 2) {
      newValue = e + "-";
      newPlaceholder = newValue + ogPlaceholder.substring(newValue.length);
    } else {
      newValue = e;
      newPlaceholder = e + ogPlaceholder.substring(e.length);
    }
  } else {
    error = dynamicNationalIdError(currentValue);
  }
  let newState = { ...state, [field]: newValue };
  return { newPlaceholder, error, newState };
}

export default class LawEnforcement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: "",
      middleName: "",
      surname: "",
      forceNumber: "",
      rankId: 0,
      stationId: 0,
      roleId: 0,
      nationality: "",
      nationalIdNumber: "",
      passportNumber: "",
      cellPhone: "",
      gender: "",
      username: "",
      password: "",
      passwordConfirm: "",
      otpCode: "",
      errors: {},
      idPlaceholder: ogPlaceholder,
      msg: "",
      toastColor: "",
      loading: false,
      valid: false,
      companyLookupData: {},
      ranks: [],
      stations: [],
      roles: [],
      otpId: null,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleRegister = this.handleRegister.bind(this);
    this.handleId = this.handleId.bind(this);
    this.verifyCellphone = this.verifyCellphone.bind(this);
    this.validate = this.validate.bind(this);
  }
  componentDidMount() {
    this.getCompanyLookupData();
    this.getDropdownLists();
  }

  isZimbabwean() {
    return this.state.nationality === "ZW";
  }

  getCompanyLookupData() {
    var self = this;
    axios
      .get(API + "/register/getcompanydropdownlists")
      .then(function (response) {
        self.setState({ companyLookupData: response.data || {} });
      })
      .catch(function (error) {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        self.setState({
          msg:
            error?.response?.data?.message ||
            "Failed to get lookup data. Refresh page or contact administrator.",
          toastColor: "danger",
        });
      });
  }
  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value }, this.validate);
  }
  handleSelect(name, option) {
    this.setState(
      {
        [name]: option
          ? option.value
          : typeof option === "string"
          ? option
          : "",
      },
      this.validate
    );
  }
  handleId(val, field = "nationalIdNumber") {
    const { newPlaceholder, error, newState } = formatNationalId(
      val,
      this.state,
      field,
      this.isZimbabwean()
    );
    this.setState(
      {
        [field]: newState[field],
        ...(field === "nationalIdNumber"
          ? { idPlaceholder: newPlaceholder }
          : {}),
        errors: { ...this.state.errors, [field]: error },
      },
      this.validate
    );
  }
  getDropdownLists() {
    this.setState({ loading: true, msg: "", toastColor: "" });

    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "Login details not properly recorded, please return to login screen",
        toastColor: "danger",
        loading: false,
      });
      setTimeout(() => {
        window.location.href = `/?redirectUrl=${
          window.location.pathname + window.location.search
        }`;
      }, 1600);
      return;
    }

    axios
      .get(API + "/law-enforcement/register/dropdownlists", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        this.setState({
          ranks: res.data.rankList || [],
          stations: res.data.stationList || [],
          roles: res.data.roleList || [],
        });
      })
      .catch((err) => {
        if (Number(err.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          msg:
            err?.response?.data?.message ||
            "Failed to get lookup data. Refresh page or contact administrator.",
          toastColor: "danger",
          loading: false,
        });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }
  validate() {
    let s = this.state;
    let errors = {};
    let valid = true;
    if (!s.firstName || !s.firstName.trim()) {
      errors.firstName = "First Name is required";
      valid = false;
    }
    if (!s.surname || !s.surname.trim()) {
      errors.surname = "Surname is required";
      valid = false;
    }
    if (!s.forceNumber || !s.forceNumber.trim()) {
      errors.forceNumber = "Force Number is required";
      valid = false;
    }
    if (!s.rankId || s.rankId === 0) {
      errors.rankId = "Rank is required";
      valid = false;
    }
    if (!s.stationId || s.stationId === 0) {
      errors.stationId = "Station is required";
      valid = false;
    }
    if (!s.roleId || s.roleId === 0) {
      errors.roleId = "Role is required";
      valid = false;
    }
    if (!s.nationality || !s.nationality.trim()) {
      errors.nationality = "Nationality is required";
      valid = false;
    }
    if (this.isZimbabwean()) {
      if (!s.nationalIdNumber || !s.nationalIdNumber.trim()) {
        errors.nationalIdNumber = "National ID is required";
        valid = false;
      } else if (!nationalIdRegex.test(s.nationalIdNumber)) {
        errors.nationalIdNumber = dynamicNationalIdError(s.nationalIdNumber);
        valid = false;
      }
    } else {
      if (!s.passportNumber || !s.passportNumber.trim()) {
        errors.passportNumber = "Passport Number is required";
        valid = false;
      }
    }
    if (!s.cellPhone || !s.cellPhone.trim()) {
      errors.cellPhone = "Cellphone is required";
      valid = false;
    } else if (!phoneRegex.test(s.cellPhone)) {
      errors.cellPhone = phoneError;
      valid = false;
    } else if (!s.otpId || s.otpId === 0) {
      errors.cellPhone = "Cellphone is not verified";
      valid = false;
    }
    if (!s.gender || !s.gender.trim()) {
      errors.gender = "Gender is required";
      valid = false;
    }
    if (!s.username || !s.username.trim()) {
      errors.username = "Username is required";
      valid = false;
    } else if (!usernameRegex.test(s.username)) {
      errors.username = usernameError;
      valid = false;
    }
    if (!s.password || !s.password.trim()) {
      errors.password = "Password is required";
      valid = false;
    } else if (!passwordRegex.test(s.password)) {
      errors.password = passwordError;
      valid = false;
    }
    if (!s.passwordConfirm || !s.passwordConfirm.trim()) {
      errors.passwordConfirm = "Password Confirm is required";
      valid = false;
    } else if (s.password !== s.passwordConfirm) {
      errors.passwordConfirm = "Passwords do not match";
      valid = false;
    } else if (!passwordRegex.test(s.passwordConfirm)) {
      errors.passwordConfirm = passwordError;
      valid = false;
    }
    if (!s.otpCode || !s.otpCode.trim()) {
      errors.otpCode = "OTP is required";
      valid = false;
    }
    this.setState({ errors, valid });
    return valid;
  }
  verifyCellphone(e) {
    if (e) e.preventDefault();
    if (!this.state.cellPhone || !phoneRegex.test(this.state.cellPhone)) {
      this.setState({
        errors: { ...this.state.errors, cellPhone: phoneError },
      });
      return;
    }
    this.setState({ loading: true, msg: "", toastColor: "" });
    axios
      .post(API + "/register/mobile/generateotpcode", null, {
        params: { mobile: this.state.cellPhone },
      })
      .then((response) => {
        this.setState({ otpId: response.data, loading: false });
      })
      .catch(() => {
        this.setState({
          msg: "Failed to get OTP.",
          toastColor: "danger",
          loading: false,
        });
      });
  }
  handleRegister(e) {
    e.preventDefault();
    this.setState({ loading: true, msg: "", toastColor: "" });
    if (!this.validate()) {
      this.setState({
        msg: "Fix the errors above and try again.",
        toastColor: "danger",
        loading: false,
      });
      return;
    }

    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "Login details not properly recorded, please return to login screen",
        toastColor: "danger",
        loading: false,
      });
      setTimeout(() => {
        window.location.href = `/?redirectUrl=${
          window.location.pathname + window.location.search
        }`;
      }, 1600);
      return;
    }

    const req = {
      user: {
        username: this.state.username,
        password: this.state.password,
        userType: "LAW_ENFORCEMENT",
        fullName: [
          this.state.firstName,
          this.state.middleName,
          this.state.surname,
        ].join(" "),
        mobileVerified: "NO",
        activeStatus: "YES",
        emailVerified: "NO",
        isPaidService: "NO",
        roleId: this.state.roleId,
      },
      otpCode: Number(this.state.otpCode),
      lawEnforcementProfile: {
        id: 0,
        firstName: this.state.firstName,
        surname: this.state.surname,
        middleName: this.state.middleName,
        forceNumber: this.state.forceNumber,
        rankId: this.state.rankId,
        stationId: this.state.stationId,
        nationalIdNumber: this.state.nationalIdNumber,
        passportNumber: this.state.passportNumber,
        nationality: this.state.nationality,
        cellPhone: this.state.cellPhone,
      },
    };
    var self = this;
    axios
      .post(API + "/law-enforcement/register", req, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(function (response) {
        if (response.data.success) {
          self.setState({
            msg: "Registration successful! Redirecting to login...",
            toastColor: "success",
            loading: false,
          });
          setTimeout(() => {
            window.location.href = "/";
          }, 1700);
        } else {
          self.setState({
            msg: response.data.message || "Registration failed",
            toastColor: "danger",
            loading: false,
          });
          if (
            response.data.message &&
            response.data.message.includes("username already exist")
          ) {
            self.setState({
              errors: { ...self.state.errors, username: response.data.message },
            });
          }
        }
      })
      .catch(function (error) {
        self.setState({
          msg:
            error?.response?.data?.message ||
            "Registration failed. Please try again.",
          toastColor: "danger",
          loading: false,
        });
      });
  }
  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }
    if (s.loading) {
      return <Spinner className="" />;
    }
    return (
      <div className="min-h-screen h-dvh flex justify-between bg-white">
        <Sidebar />
        <div className="min-h-screen w-[85%] flex flex-col">
          <Banner title="Register as Law Enforcement" />
          {divMsg}
          <form
            className={"flex flex-col items-center w-full mt-2 overflow-y-auto"}
            autoComplete="off"
            onSubmit={this.handleRegister}
          >
            <div className="w-full max-w-5xl">
              <div className="grid grid-cols-2 gap-x-8 gap-y-4">
                <div className="input-group">
                  <label className="input-group-text">First Name</label>
                  <input
                    name="firstName"
                    className={`form-control ${
                      s.errors.firstName ? " !border-red-500" : ""
                    }`}
                    value={s.firstName}
                    onChange={this.handleChange}
                    required
                    autoFocus
                  />
                  {s.errors.firstName && (
                    <span className="input-group-error">
                      {s.errors.firstName}
                    </span>
                  )}
                </div>
                <div className="input-group">
                  <label className="input-group-text">Middle Name</label>
                  <input
                    name="middleName"
                    className={`form-control ${
                      s.errors.middleName ? " !border-red-500" : ""
                    }`}
                    value={s.middleName}
                    onChange={this.handleChange}
                  />
                  {s.errors.middleName && (
                    <span className="input-group-error">
                      {s.errors.middleName}
                    </span>
                  )}
                </div>
                <div className="input-group">
                  <label className="input-group-text">Surname</label>
                  <input
                    name="surname"
                    className={`form-control ${
                      s.errors.surname ? " !border-red-500" : ""
                    }`}
                    value={s.surname}
                    onChange={this.handleChange}
                    required
                  />
                  {s.errors.surname && (
                    <span className="input-group-error">
                      {s.errors.surname}
                    </span>
                  )}
                </div>
                <div className="input-group">
                  <label className="input-group-text">Force Number</label>
                  <input
                    name="forceNumber"
                    className={`form-control ${
                      s.errors.forceNumber ? " !border-red-500" : ""
                    }`}
                    value={s.forceNumber}
                    onChange={this.handleChange}
                    required
                  />
                  {s.errors.forceNumber && (
                    <span className="input-group-error">
                      {s.errors.forceNumber}
                    </span>
                  )}
                </div>
                <div className="input-group">
                  <label className="input-group-text required">Rank</label>
                  <Select
                    name="rankId"
                    options={s.ranks.map((r) => ({
                      value: r.id,
                      label: r.name,
                    }))}
                    value={
                      s.ranks.find((r) => r.id === s.rankId)
                        ? {
                            value: s.rankId,
                            label: s.ranks.find((r) => r.id === s.rankId).name,
                          }
                        : null
                    }
                    onChange={(option) => this.handleSelect("rankId", option)}
                    className={`form-control ${
                      s.errors.rankId ? " !border-red-500" : ""
                    }`}
                    required
                  />
                  {s.errors.rankId && (
                    <span className="input-group-error">{s.errors.rankId}</span>
                  )}
                </div>
                <div className="input-group">
                  <label className="input-group-text required">Station</label>
                  <Select
                    name="stationId"
                    options={s.stations.map((r) => ({
                      value: r.id,
                      label: r.name,
                    }))}
                    value={
                      s.stations.find((r) => r.id === s.stationId)
                        ? {
                            value: s.stationId,
                            label: s.stations.find((r) => r.id === s.stationId)
                              .name,
                          }
                        : null
                    }
                    onChange={(option) =>
                      this.handleSelect("stationId", option)
                    }
                    className={`form-control ${
                      s.errors.stationId ? " !border-red-500" : ""
                    }`}
                    required
                  />
                  {s.errors.stationId && (
                    <span className="input-group-error">
                      {s.errors.stationId}
                    </span>
                  )}
                </div>
                <div className="input-group">
                  <label className="input-group-text required">Role</label>
                  <Select
                    name="roleId"
                    options={s.roles.map((r) => ({
                      value: r.id,
                      label: r.name,
                    }))}
                    value={
                      s.roles.find((r) => r.id === s.roleId)
                        ? {
                            value: s.roleId,
                            label: s.roles.find((r) => r.id === s.roleId).name,
                          }
                        : null
                    }
                    onChange={(option) => this.handleSelect("roleId", option)}
                    className={`form-control ${
                      s.errors.roleId ? " !border-red-500" : ""
                    }`}
                    required
                  />
                  {s.errors.roleId && (
                    <span className="input-group-error">{s.errors.roleId}</span>
                  )}
                </div>
                <div className="input-group">
                  <label className="input-group-text">Nationality</label>
                  <Select
                    name="nationality"
                    value={(s.companyLookupData.countrys || []).find(
                      ({ value }) => value === s.nationality
                    )}
                    onChange={(option) => {
                      this.handleId("", "nationalIdNumber");
                      this.handleId("", "passportNumber");
                      this.setState({ idPlaceholder: ogPlaceholder });
                      this.handleSelect("nationality", option);
                    }}
                    className={`form-control ${
                      s.errors.nationality ? " !border-red-500" : ""
                    }`}
                    required
                    options={s.companyLookupData.countrys || []}
                  />
                  {s.errors.nationality && (
                    <span className="input-group-error">
                      {s.errors.nationality}
                    </span>
                  )}
                </div>
                {!!s.nationality && this.isZimbabwean() ? (
                  <div className="input-group">
                    <label className="input-group-text">National ID</label>
                    <input
                      name="nationalIdNumber"
                      className={`form-control ${
                        s.errors.nationalIdNumber ? " !border-red-500" : ""
                      }`}
                      value={s.nationalIdNumber}
                      placeholder={s.idPlaceholder}
                      onChange={(e) =>
                        this.handleId(e.target.value, "nationalIdNumber")
                      }
                      required
                    />
                    {s.errors.nationalIdNumber && (
                      <span className="input-group-error">
                        {s.errors.nationalIdNumber}
                      </span>
                    )}
                  </div>
                ) : !!s.nationality ? (
                  <div className="input-group">
                    <label className="input-group-text">Passport Number</label>
                    <input
                      name="passportNumber"
                      className={`form-control ${
                        s.errors.passportNumber ? " !border-red-500" : ""
                      }`}
                      value={s.passportNumber}
                      onChange={(e) =>
                        this.handleId(e.target.value, "passportNumber")
                      }
                      required
                    />
                    {s.errors.passportNumber && (
                      <span className="input-group-error">
                        {s.errors.passportNumber}
                      </span>
                    )}
                  </div>
                ) : null}
                <div className="input-group">
                  <label className="input-group-text">Gender</label>
                  <select
                    name="gender"
                    className={`form-control ${
                      s.errors.gender ? " !border-red-500" : ""
                    }`}
                    value={s.gender}
                    onChange={this.handleChange}
                    required
                  >
                    <option value="">Select</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </select>
                  {s.errors.gender && (
                    <span className="input-group-error">{s.errors.gender}</span>
                  )}
                </div>
                <div className="col-span-2 grid grid-cols-2 gap-x-8 gap-y-4">
                  <div className="input-group relative">
                    <label className="input-group-text">Cellphone</label>
                    <input
                      name="cellPhone"
                      className={`form-control ${
                        s.errors.cellPhone ? " !border-red-500" : ""
                      }`}
                      value={s.cellPhone}
                      onChange={this.handleChange}
                      required
                    />
                    {s.errors.cellPhone && (
                      <span className="input-group-error">
                        {s.errors.cellPhone}
                      </span>
                    )}
                    {!s.otpId && (
                      <button
                        type="button"
                        className="btn btn-success"
                        onClick={this.verifyCellphone}
                      >
                        Verify
                      </button>
                    )}
                  </div>
                  {s.otpId && (
                    <div className="input-group gap-2">
                      <label className="input-group-text required">
                        OTP Code
                      </label>
                      <OtpInput
                        key={`law-enforcement-otp`}
                        length={5}
                        onReset={(code) =>
                          this.setState({ otpCode: code }, this.validate)
                        }
                        onComplete={(code) =>
                          this.setState({ otpCode: code }, this.validate)
                        }
                        autofocus={false}
                      />
                      {s.errors.otpCode && (
                        <span className="input-group-error">
                          {s.errors.otpCode}
                        </span>
                      )}
                    </div>
                  )}
                </div>
                <div className="input-group col-span-2">
                  <label className="input-group-text">Username</label>
                  <input
                    name="username"
                    className={`form-control ${
                      s.errors.username ? " !border-red-500" : ""
                    }`}
                    value={s.username}
                    onChange={this.handleChange}
                    required
                  />
                  {s.errors.username && (
                    <span className="input-group-error">
                      {s.errors.username}
                    </span>
                  )}
                </div>
                <div className="input-group">
                  <label className="input-group-text">Password</label>
                  <input
                    name="password"
                    type="password"
                    className={`form-control ${
                      s.errors.password ? " !border-red-500" : ""
                    }`}
                    value={s.password}
                    onChange={this.handleChange}
                    required
                  />
                  {s.errors.password && (
                    <span className="input-group-error">
                      {s.errors.password}
                    </span>
                  )}
                </div>
                <div className="input-group">
                  <label className="input-group-text">Password Confirm</label>
                  <input
                    name="passwordConfirm"
                    type="password"
                    className={`form-control ${
                      s.errors.passwordConfirm ? " !border-red-500" : ""
                    }`}
                    value={s.passwordConfirm}
                    onChange={this.handleChange}
                    required
                  />
                  {s.errors.passwordConfirm && (
                    <span className="input-group-error">
                      {s.errors.passwordConfirm}
                    </span>
                  )}
                </div>
              </div>
              <div className="flex justify-center gap-8 mt-2">
                {s.valid && (
                  <button type="submit" className="btn btn-success">
                    Register
                  </button>
                )}
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() => window.history.back()}
                >
                  Cancel
                </button>
              </div>
            </div>
          </form>
          <Footer />
        </div>
      </div>
    );
  }
}
